import dlv from 'dlv';

import { IStaticPageRoute } from 'remote/queries/static-page';
import { PROD_DEFAULT_LANGUAGE } from 'state/intl/supported-languages';

export interface LocaleRoutes {
  acceptGift: string;
  account: string;
  sendGift: string;
  exploreMenu: string;
  signUp: string;
  signIn: string;
  storeLocator: string;
  quiz: string;
  timsForGood: string;
  userPreferencesModal: string;
}

export const localeRoutes: Record<string, LocaleRoutes> = {
  en: {
    acceptGift: '/accept-gift',
    account: '/account',
    sendGift: '/gift',
    exploreMenu: '/explore-menu',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    quiz: '/quiz',
    timsForGood: '/tims-for-good',
    userPreferencesModal: '/user-preferences-modal',
  },
  fr: {
    acceptGift: '/accepter-un-cadeau',
    account: '/compte',
    sendGift: '/cadeau',
    exploreMenu: '/nouveaux-gouts',
    signUp: '/inscrivez-vous',
    signIn: '/connectez-vous',
    storeLocator: '/localisateur-de-magasin',
    quiz: '/quiz',
    timsForGood: '/timdubienauquotidien',
    userPreferencesModal: '/user-preferences-modal',
  },
  de: {
    acceptGift: '/accept-gift',
    account: '/account',
    sendGift: '/gift',
    exploreMenu: '/unser-menu',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    quiz: '/quiz',
    timsForGood: '/tims-for-good',
    userPreferencesModal: '/user-preferences-modal',
  },
};

export function getAllLocalizedVersionsOfRoute(routeKey: keyof LocaleRoutes) {
  const routes = Object.values(localeRoutes).map(routeMaps => routeMaps[routeKey]);
  return routes.filter(Boolean);
}

export const getStaticPagesLocalizedRouteForPath = (
  path: string,
  staticRoutes: IStaticPageRoute[],
  language: string
) => {
  if (!staticRoutes || !Array.isArray(staticRoutes)) {
    return null;
  }

  let localizedRelativePath = null;

  staticRoutes.forEach((route: any) => {
    if (dlv(route, 'path.current') === path) {
      const localizedPathWithFallback =
        dlv(route, `localePath.${language}.current`) || route.path.current;
      localizedRelativePath = `/${localizedPathWithFallback}`;
    }
  });

  return localizedRelativePath;
};

export const getInCodeLocalizedRouteForPath = (
  relativePath: string,
  language: string,
  region: string
) => {
  const defaultLanguageLocaleRoutes = localeRoutes[PROD_DEFAULT_LANGUAGE[region]];

  const defaultLanguageRouteKey = Object.keys(defaultLanguageLocaleRoutes).find(
    key => defaultLanguageLocaleRoutes[key] === relativePath
  );

  if (defaultLanguageRouteKey) {
    return (
      dlv(localeRoutes, `${language}.${defaultLanguageRouteKey}`) ||
      defaultLanguageLocaleRoutes[defaultLanguageRouteKey]
    );
  }

  return null;
};
